import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ESliceKeys } from '../../internal/ESliceKeys';

export type ListingLayoutState = {
  filtersHeight: number;
  isShort: boolean;
};

const listingLayoutInitialState: ListingLayoutState = {
  filtersHeight: 0,
  /**
   * @todo Поменять значение на false
   * @description Данные доработки должны быть сделаны в задаче CD-193764 вместе с удалением фича-тоггла isDefaultWideListingEnabled
   */
  isShort: true,
};

export const { reducer: listingLayoutReducer, actions: listingLayoutActions } = createSlice({
  initialState: listingLayoutInitialState,
  name: ESliceKeys.ListingLayout,
  reducers: {
    setFiltersHeight(state, action: PayloadAction<number>) {
      state.filtersHeight = action.payload;
    },
    setIsShort(state, action: PayloadAction<boolean>) {
      state.isShort = action.payload;
    },
    toggleIsShort(state) {
      state.isShort = !state.isShort;
    },
  },
});
